<mat-nav-list role="navigation" appAccordion aria-label="Main navigation">
  @for (menuitem of sideMenuitems; track menuitem; let i = $index) {
    <mat-list-item
      appAccordionLink
      [sidebarOpen]="sidebarOpened"
      routerLinkActive="selected"
      group="{{ menuitem?.state }}"
      selectItem="{{ menuitem?.type }}"
      (click)="scrollToTop()"
      class="mb-2"
    >
      @if (menuitem?.type === 'link') {
        <a
          class="flex items-center py-md px-md w-full"
          appAccordionToggle
          [routerLink]="menuitem?.state"
          (click)="closeSideBar()"
        >
          <mat-icon class="mr-sm">{{ menuitem?.icon }}</mat-icon>
          <span class="ml-3">{{ menuitem?.name }}</span>
          <span></span>
          @for (badge of menuitem?.badge; track badge) {
            <span class="label label-{{ badge?.type }}">{{ badge?.value }}</span>
          }
        </a>
      }
      @if (menuitem?.type === 'sub') {
        <a class="flex items-center custom-dropdown py-md px-md w-full" appAccordionToggle>
          <mat-icon class="mr-sm">{{ menuitem?.icon }}</mat-icon>
          <span class="ml-3">{{ menuitem?.name }}</span>
          <span class="flex-1"></span>
          @for (badge of menuitem?.badge; track badge) {
            <span class="label label-{{ badge?.type }}">{{ badge?.value }}</span>
          }
          <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>
      }
      @if (menuitem?.type === 'sub') {
        <mat-nav-list role="navigation" class="sub-item" [attr.aria-label]="menuitem?.name + ' navigation'">
          @for (childitem of menuitem.children; track childitem; let j = $index) {
            <mat-list-item routerLinkActive="selected">
              @if (childitem?.type === 'link') {
                <a
                  [routerLink]="menuitem?.state ? ['/', menuitem?.state, childitem?.state] : ['/', childitem?.state]"
                  class="relative sub-item-link"
                  routerLinkActive="selected"
                  (click)="itemSelect[j] = j; closeSideBar(); $event.preventDefault()"
                  >{{ childitem?.name }}</a
                >
              }
            </mat-list-item>
          }
        </mat-nav-list>
      }
      @if (menuitem?.type === 'saperator') {
        <div class="saperator text-muted">
          <span>{{ menuitem.name }}</span>
        </div>
      }
    </mat-list-item>
  }
</mat-nav-list>
